import styled from 'styled-components'

export const AddressText = styled.div`
  ${({ theme }) => theme.typography['body-base']};
`
